import { isCheckedInClient } from "src/utils/checkedInUser";

export const WEB_DASHBOARD_ACCESS = 1;
export const MY_ME_APP = 2;
export const USER_LISTS = 3;
export const NOTICEBOARD = 4;
export const SURVEYS = 5;
export const STATISTICS = 6;
export const SALES_AND_PROMOTIONS = 7;
export const BILLING = 8;
export const NOTICEBOARD_APP = 9;
export const CREATE_BUSINESS_PLAYLISTS = 10;
export const FULL_ACCESS_BUSINESS_CHAT = 11;
export const MESSAGE_EMPLOYEES = 12;
export const MESSAGE_CLIENTS = 13;
export const CREATE_GROUP_CHAT = 14;
export const ACCOUNT_OWNER_PERMISSION = 15;
export const TEAM_GOALS = 16;
export const BUSINESS_DIRECTORY = 17;
export const PERKS = 18;
export const ADVERTISING = 19;
export const SOCIAL_MEDIA_LINKING_POSTING = 20;
export const SOCIAL_MEDIA_POSTING = 21;
export const DIGITAL_MEMBER_CARDS = 22;
export const MY_QUOTE = 23;
export const CLIENT_NOTICEBOARD = 24;
export const BODY_AND_MIND = 25;
export const EMAIL_CAMPAIGNS = 26;
// 27-29 was assigned different permissions from api (MY_CONTACTS, SOCIAL_PROCUREMENT, JOB_LISTINGS)
export const DOCUMENTS_VIEW = 30;
export const LEADERSHIP_ROLES = 31;
export const CHECKLISTS = 32;
export const POLLS = 33;
export const DONATIONS = 34;
export const CALENDAR_EMPLOYEE_ADMIN = 35;
export const CALENDAR_CLIENT_ADMIN = 36;
export const STORAGE_MANAGEMENT = 37;

/**
 * @param {array} requiredPermissions
 * @param {array} userPermissions
 */
export const hasPermissions = (requiredPermissions, userPermissions) => {
    return userPermissions.length > 0
        ? requiredPermissions.every(val => userPermissions.includes(val))
        : false;
};

export const hasAnyPermission = (requiredPermissions, userPermissions) => {
    return userPermissions.length > 0
        ? requiredPermissions.some(val => userPermissions.includes(val))
        : false;
};

/**
 * @param {int} implicitPermission
 * @param {array} userPermissions
 * @returns
 */
export const hasImplicitPermission = (implicitPermission, userPermissions) => {
    return userPermissions.length > 0 ? userPermissions.includes(implicitPermission) : false;
};

/**
 * checks whether the user has either the required permission
 * or an implicit FULL_ACCESS_BUSINESS_CHAT
 * @param {int} permissionId
 * @param {array} userPermissions
 * @returns
 */
export const isChatActionAllowed = (permissionId, userPermissions) => {
    const withImplicit = hasImplicitPermission(FULL_ACCESS_BUSINESS_CHAT, userPermissions);
    return withImplicit || hasPermissions([permissionId], userPermissions);
};

export const getLowestPermissionRoute = (permissions, appVariant, isClient) =>
    isCheckedInClient({ appVariant, isClient }) ? "/noticeboard" : "/active";

export const hasChatPermission = (permissionIds) => {
    if (!permissionIds) return false;

    let parsedPermissions = [];

    try {
        parsedPermissions = typeof permissionIds === "string"
            ? JSON.parse(permissionIds)
            : permissionIds;
    } catch {
        return false;
    }

    return (
        isChatActionAllowed(FULL_ACCESS_BUSINESS_CHAT, parsedPermissions) ||
        isChatActionAllowed(MESSAGE_EMPLOYEES, parsedPermissions) ||
        isChatActionAllowed(MESSAGE_CLIENTS, parsedPermissions) ||
        isChatActionAllowed(CREATE_GROUP_CHAT, parsedPermissions)
    );
};
